import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const LogoText = styled("span")(({ theme }) => ({
  color: "inherit",
  fontFamily: "Roboto",
  fontWeight: "500",
  fontSize: "2.5rem"
}));

export const Logo = () => {
  return (
    <Box display="flex" alignItems="center">
      <img
        //src="./images/logo/logo_transparent_small.png"
        src="./images/logo/logo_gear_white_noborder.svg"
        alt="DEVEX Logo"
        style={{ height: "2em" }}
      />
      <LogoText>DEVEX</LogoText>
    </Box>
  );
};